import { jsonToCSV } from 'react-papaparse';

export type UploadSummarySampleRow = Record<string, string | number>;

export const UPLOAD_SUMMARY_SAMPLE_JSON_PATH = '/json/upload_summary_sample.json';

const VENDOR_COLUMN = 'Vendor';

/**
 * Excel assumes the local ANSI codepage for a CSV without a byte order mark, which mangles
 * Organization names outside ASCII. The static sample CSV shipped with one, so the generated one
 * has to as well.
 */
const UTF8_BOM = '﻿';

export function buildVendorColumnDescription(vendorNames: string[]): string {
  if (vendorNames.length === 0) {
    return 'Required';
  }

  return ['Required', '', 'Must be one of:', ...vendorNames].join('\r\n');
}

export function applyVendorOptionsToSample(
  rows: UploadSummarySampleRow[],
  vendorNames: string[],
  defaultVendorName?: string
): UploadSummarySampleRow[] {
  if (rows.length === 0) {
    return rows;
  }

  const [descriptionRow, ...exampleRows] = rows;
  const exampleVendor = defaultVendorName ?? vendorNames[0];

  return [
    { ...descriptionRow, [VENDOR_COLUMN]: buildVendorColumnDescription(vendorNames) },
    ...exampleRows.map(row =>
      VENDOR_COLUMN in row && exampleVendor !== undefined
        ? { ...row, [VENDOR_COLUMN]: exampleVendor }
        : row
    ),
  ];
}

export function sampleToJson(rows: UploadSummarySampleRow[]): string {
  return JSON.stringify(rows, null, 2);
}

export function sampleToCsv(rows: UploadSummarySampleRow[]): string {
  return `${UTF8_BOM}${jsonToCSV(rows, { escapeFormulae: true })}`;
}

export async function fetchUploadSummarySample(): Promise<UploadSummarySampleRow[]> {
  const response = await fetch(UPLOAD_SUMMARY_SAMPLE_JSON_PATH);

  if (!response.ok) {
    throw new Error(`Failed to load sample summary file (${response.status})`);
  }

  return response.json();
}
